import { useState } from 'react';
import { useEventValueCallback } from '@wix/da-hooks/pkg/useEventValueCallback';
export var DownloadType;
(function (DownloadType) {
    DownloadType["FREE"] = "free";
    DownloadType["PREMIUM"] = "premium";
})(DownloadType || (DownloadType = {}));
export function useDownloadType(initialType) {
    var _a = useState(initialType), selectedType = _a[0], setSelectedType = _a[1];
    return {
        selectedType: selectedType,
        setSelectedType: useEventValueCallback(function (value) {
            return value
                ? setSelectedType(value)
                : setSelectedType(undefined);
        }, [setSelectedType]),
    };
}
//# sourceMappingURL=utils.js.map